// @flow

import type { AbsenceReviewState } from "./types";

export const initialState: AbsenceReviewState = {
  requestsInProgress: 0,
  error: null,
  lastReviewTask: null,
  selectedReferralDecisionTask: null,
  referralDecisionTask: null,
  selectedReviewTask: null,
  task: null,
};

export default initialState;
